"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M7 3.5V13H2.5c-.827 0-1.5-.673-1.5-1.5v-8C1 2.673 1.673 2 2.5 2h3C6.327 2 7 2.673 7 3.5Zm1 8.691v-8.46C8.564 3.315 9.76 3 10.5 3h9.179c.624 0 1.166.404 1.289.962.099.448-.033.883-.362 1.193a.5.5 0 0 0 .286.861A1.246 1.246 0 0 1 22 7.25c0 .344-.141.666-.395.905a.5.5 0 0 0 .286.861A1.246 1.246 0 0 1 23 10.25c0 .466-.262.89-.685 1.105a.502.502 0 0 0-.034.871c.491.303.765.845.712 1.415-.07.762-.778 1.359-1.612 1.359H14.5a.503.503 0 0 0-.412.216.503.503 0 0 0-.055.462c.009.025.967 2.562.967 4.322 0 1.638-1.452 3-2 3-.431 0-.792-.156-1-.271V19.5a.51.51 0 0 0-.046-.21l-3-6.5a.5.5 0 0 0-.23-.237L8 12.191ZM5.5 1h-3A2.502 2.502 0 0 0 0 3.5v8C0 12.879 1.121 14 2.5 14h5a.5.5 0 0 0 .5-.5v-.191l.119.061L11 19.609V23a.5.5 0 0 0 .188.391c.031.024.774.609 1.812.609 1.157 0 3-1.831 3-4 0-1.368-.49-3.071-.796-4h6.177c1.346 0 2.491-.996 2.608-2.267a2.483 2.483 0 0 0-.64-1.909c.412-.413.651-.973.651-1.574a2.24 2.24 0 0 0-1.234-2.001 2.24 2.24 0 0 0-1.001-3c.228-.456.295-.981.18-1.503C21.721 2.734 20.768 2 19.679 2H10.5c-.695 0-1.815.225-2.647.653A2.506 2.506 0 0 0 5.5 1Z",
    clipRule: "evenodd"
  })]
});